import { render, staticRenderFns } from "./StudyTable.vue?vue&type=template&id=7a01950a&scoped=true"
import script from "./StudyTable.vue?vue&type=script&lang=js"
export * from "./StudyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a01950a",
  null
  
)

export default component.exports